import { post } from '.';

export function OpenInMyKaarma(options = {}) {
	return post<any>("/app/api/mykaarma/open", options);
}
